import type { Locale } from '@seek/melways-sites';
import React from 'react';
import { hydrate } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import type { ConfigOptions } from 'src/app/contexts/ExpressUIConfigProvider/types';
import { authenticate } from 'src/app/utils/authenticate';
import { installTrackJS, loadDatadog } from 'src/app/utils/logging';
import loadSift from 'src/app/utils/sift';
import type { EmployerSiteName } from 'src/types/app';

import App from './App';
import setLocalSeekId from './utils/localSeekId';
import { persistUivParams } from './views/shared/UivController/utils/persistUivParams';

interface Props {
  language: Locale;
  site: EmployerSiteName;
  config: ConfigOptions;
}

export default async ({ language, site, config }: Props) => {
  persistUivParams();
  installTrackJS();
  loadDatadog();
  await authenticate();
  loadSift();
  setLocalSeekId();

  hydrate(
    <BrowserRouter>
      <App config={config} site={site} language={language} />
    </BrowserRouter>,
    document.getElementById('app'),
  );
};
